import script from "./Title.vue?vue&type=script&lang=ts&setup=true"
export * from "./Title.vue?vue&type=script&lang=ts&setup=true"

import "./Title.vue?vue&type=style&index=0&id=16ffedb1&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ffedb1"]])

export default __exports__